// extracted by mini-css-extract-plugin
export var content = "Footer-module--content--JucMo";
export var footer = "Footer-module--footer--iScRn";
export var logo = "Footer-module--logo--6IOUR";